export enum BubbleColors {
    Color1 = "#03A9F4",  // 1
    Color2 = "#81D4FA",  // 2
    Color3 = "#B3E5FC",  // 3
    Color4 = "#80DEEA",  // 4
    Color5 = "#B2EBF2",  // 5
    Color6 = "#D4F6FB"   // 6
}